export default function BookingApi({ makeRequest, buildRequest }) {
	function createTourBooking(payload) {
		return buildRequest().then((req) =>
			makeRequest(req.post('/api/booking', payload))
		);
	}

	function rescheduleTourBooking(enquiryCentreTourId, payload) {
		return buildRequest().then((req) =>
			makeRequest(req.put(`/api/booking/${enquiryCentreTourId}/reschedule`, payload))
		);
	}

	function cancelTourBooking(enquiryCentreTourId, payload) {
		return buildRequest().then((req) =>
			makeRequest(req.put(`/api/booking/${enquiryCentreTourId}/cancel`, payload))
		);
	}

	function completeTourBooking(enquiryCentreTourId, payload) {
		return buildRequest().then((req) =>
			makeRequest(req.put(`/api/booking/${enquiryCentreTourId}/complete`, payload))
		);
	}

	function updateTourBooking(enquiryCentreTourId, payload) {
		return buildRequest().then((req) =>
			makeRequest(req.put(`/api/booking/${enquiryCentreTourId}/update`, payload))
		);
	}

	function getBookings(centreId, from, to) {
		return buildRequest().then((req) =>
			makeRequest(req.get(`/api/Booking/${centreId}`, { params: { from, to } }))
		);
	}

	function getBooking(calendarBookingId) {
		return buildRequest().then((req) =>
			makeRequest(req.get(`/api/Booking/${calendarBookingId}?includeDeleted=true`))
		);
	}

	return {
		createTourBooking,
		rescheduleTourBooking,
		cancelTourBooking,
		completeTourBooking,
		updateTourBooking,
		getBookings,
		getBooking,
	};
}